import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

const Blog = ({ setPage }) => {
  useEffect(() => {
    setPage("landing");
  });
  return (
    <>
      <div className="outer__inner landng">
        <div className="section onex_d">
          <div className="onex_d__center center">
            <div className="onex_d__head">
              <div className="faq__stage">Our Blog</div>
              <h1 className="onex_d__title h1">Latest Releases</h1>
              <div className="onex_d__info">
                Praesent interdum, libero ut tempus rutrum.
              </div>
            </div>
            <div className="onex_d__video">
              <img src="/assets/img/hero.png" alt="" />
            </div>
          </div>
        </div>

        <div className="section-bg app section-mb0 releases">
          <div className="releases__center center">
            <div className="releases__list">
              <NavLink className="releases__item" to="/blog-details">
                <div className="releases__preview">
                  <img src="/assets/img/content/main-pic-3.jpg" alt="" />
                </div>
                <div className="releases__details">
                  <h4 className="releases__subtitle h4">
                    Vivamus ultricies enim nec
                  </h4>
                  <div className="releases__onex_d">Mauris</div>
                  <div className="releases__content">
                    Aenean nec imperdiet purus. Aliquam mollis ut nunc in
                    pellentesque. Mauris suscipit tortor ac nisl gravida
                    fermentum. Mauris quis justo eget diam laoreet consequat.
                  </div>
                </div>
                <div className="releases__arrow">
                  <svg className="icon icon-arrow-next">
                    <use xlinkHref="#icon-arrow-next"></use>
                  </svg>
                </div>
              </NavLink>
              <NavLink className="releases__item" to="/blog-details">
                <div className="releases__preview">
                  <img src="/assets/img/content/main-pic-5.jpg" alt="" />
                </div>
                <div className="releases__details">
                  <h4 className="releases__subtitle h4">
                    Suspendisse fermentum augue at augue accumsan?
                  </h4>
                  <div className="releases__onex_d">Aliquam</div>
                  <div className="releases__content">
                    Sed malesuada ante sit amet fermentum rutrum. Nulla egestas
                    facilisis nulla sed condimentum. Aenean nulla orci,
                    convallis ac rutrum vel, convallis ac enim.
                  </div>
                </div>
                <div className="releases__arrow">
                  <svg className="icon icon-arrow-next">
                    <use xlinkHref="#icon-arrow-next"></use>
                  </svg>
                </div>
              </NavLink>
              <NavLink className="releases__item" to="/blog-details">
                <div className="releases__preview">
                  <img src="/assets/img/content/main-pic-4.jpg" alt="" />
                </div>
                <div className="releases__details">
                  <h4 className="releases__subtitle h4">
                    Ut scelerisque facilisis felis vel suscipit?
                  </h4>
                  <div className="releases__onex_d">Aenean</div>
                  <div className="releases__content">
                    Mauris nunc nibh, condimentum non ullamcorper et, pretium ac
                    purus. Orci varius natoque penatibus et magnis dis
                    parturient montes, nascetur ridiculus mus. Quisque metus
                    erat, laoreet quis tempus a, imperdiet vel enim. Vestibulum
                    feugiat gravida elit, eu dignissim arcu faucibus in.
                  </div>
                </div>
                <div className="releases__arrow">
                  <svg className="icon icon-arrow-next">
                    <use xlinkHref="#icon-arrow-next"></use>
                  </svg>
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
